import { useGetApiV1CourseregistrationSharedSubStatusReasonList } from '@/shared/api/generated';

import type { StatusReasonOption } from './useStatusReasons';

/**
 * Submotivos vinculados a um motivo de status. A query só é executada quando
 * {@link statusReasonId} é um número positivo (evita request para reasonId vazio).
 *
 * @param statusReasonId - ID do motivo selecionado.
 */
export function useSubStatusReasons(statusReasonId?: number) {
  const enabled = typeof statusReasonId === 'number' && statusReasonId > 0;

  const query = useGetApiV1CourseregistrationSharedSubStatusReasonList(
    enabled ? { statusReasonId } : undefined,
    { query: { enabled } },
  );

  const subReasons: readonly StatusReasonOption[] = (query.data ?? []).map(item => ({
    id: String(item.key ?? ''),
    name: item.value ?? '',
  }));

  return {
    subReasons,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
